import React, { useEffect, useState } from "react";
import { v4 } from "uuid";
import { Row, Col, Select, Button, Input, Tag, Mentions, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { returnDataArrayObject } from "../../../../../utils/arrayHelper";
import NotFound from "../../../../../components/NotFound";
import { resetAggBuilders, updateAggColBuilders, updateSelectedFields } from "../../../../../redux/editorSlice";
import DeleteIcon from "../../../../../assets/icons/delete-icon.svg";

const { Option } = Select;

function tagRender(props) {
  const { label, closable, onClose } = props;
  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag onMouseDown={onPreventMouseDown} closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
      {label}
    </Tag>
  );
}

export default function ColBuilder(props) {
  const [builders, setBuilders] = useState([]);
  const dispatch = useDispatch();

  // one empty column builder - the panel always shows at least this
  const makeBlankColBuilder = () => ({
    id: v4(),
    displayName: "",
    rowAggregation: [
      {
        id: v4(),
        fieldName: "none",
        operator: "none",
      },
    ],
  });

  const setBuilderItem = () => {
    setBuilders((b) => [...b, makeBlankColBuilder()]);
  };

  /* Removing the last one leaves an empty builder rather than nothing, so the panel is
     never a blank space with only "+ Add New" in it. */
  const deleteBuilderItem = (item) => {
    const remaining = builders.filter((f) => f.id !== item.id);
    setBuilders(remaining.length ? remaining : [makeBlankColBuilder()]);
  };

  useEffect(() => {
    const rows = props.selectedResource?.aggregation?.row || [];
    if (Boolean(rows.length)) {
      let currentBuilders = rows.map((bd) => {
        return {
          id: bd.id,
          displayName: bd.displayName,
          rowAggregation: bd.rowAggregation,
        };
      });
      setBuilders(currentBuilders);
    }
    // aggregation can be {} after a reset, so row may be undefined
    if (!Boolean(props?.selectedResource?.aggregation?.row?.length)) {
      setBuilders([makeBlankColBuilder()]);
    }
  }, [props?.selectedResource?.aggregation?.row]);

  const updateBuilder = (item, key, val) => {
    if (val !== "") {
      let currentBuilders = builders.map((bd) => {
        return bd.id === item.id
          ? {
              id: bd.id,
              displayName: key === "displayName" ? val : bd.displayName,
              rowAggregation: item.rowAggregation,
            }
          : { ...bd };
      });

      console.log("updateBuilder Call=>", currentBuilders);
      setBuilders(currentBuilders);
    }
  };

  const updateBuilderByIndex = (item, key, val, ra, i) => {
    if (val !== null || val !== "none") {
      const ubd = builders.map((b) => {
        return b.id === item.id
          ? {
              id: b.id,
              displayName: b.displayName,
              rowAggregation: b.rowAggregation.map((bra) => {
                return bra.id === ra.id
                  ? {
                      id: bra.id,
                      operator: key === "operator" ? val : bra.operator,
                      fieldNamesList: key === "fieldNamesList" ? val : bra.fieldNamesList,
                      fieldName: key === "fieldName" ? val : bra.fieldName,
                      const_1: key === "const_1" ? val : bra.const_1,
                      calculationStr: key === "calculationStr" ? val : bra.calculationStr,
                    }
                  : { ...bra };
              }),
            }
          : { ...b };
      });
      console.log("updateBuilderByIndex Call=>", ubd);
      setBuilders(ubd);
    }
  };

  const applyBuilders = (filterArray) => {
    dispatch(updateAggColBuilders(filterArray));
    message.info("Builders have been successfully applied!");
  };

  // DataBuilder owns the single Apply button for both tabs, so it needs to see
  // whatever has been configured here.
  useEffect(() => {
    if (props.onBuildersChange) props.onBuildersChange(builders);
  }, [builders]);

  const clearBuilders = () => {
    dispatch(resetAggBuilders());
    props.resetBuilders();
    setBuilders([makeBlankColBuilder()]);
    message.info("Builders have been removed!");
  };

  // return (
  //   <div style={{ display: "flex", alignItems: "center" }}>
  //     {returnDataArrayObject(props.reportDataObject) ? (
  //       <div style={{ width: "100%" }}>
  //         {builders.map((fi) => {
  //           return (
  //             <Row
  //               key={"fil_" + fi.id}
  //               gutter={16}
  //               style={{ marginTop: "16px" }}
  //             >
  //               <Col span={4}>
  //                 <div>Display Name:</div>
  //                 <div>
  //                   <Input
  //                     onChange={(e) =>
  //                       updateBuilder(fi, "displayName", e.target.value)
  //                     }
  //                     value={fi.displayName}
  //                   />
  //                 </div>
  //               </Col>

  //               {fi.rowAggregation.map((ra, n) => {
  //                 return (
  //                   <React.Fragment key={`art_${fi.id}_${n}`}>
  //                     <Col span={6}>
  //                       <div>Operation:</div>
  //                       <div>
  //                         <Select
  //                           style={{ width: "90%" }}
  //                           value={ra.operator}
  //                           onChange={(val) => {
  //                             updateBuilderByIndex(fi, "operator", val, ra, n);
  //                           }}
  //                           defaultValue='none'
  //                         >
  //                           <Option value='none' key='none'>
  //                             None
  //                           </Option>
  //                           <Option value='sum' key='add'>
  //                             Sum
  //                           </Option>
  //                           <Option value='avg' key='avg'>
  //                             Average
  //                           </Option>
  //                           <Option value='func' key='func'>
  //                             Function
  //                           </Option>
  //                           <Option value='add_c' key='add_c'>
  //                             Add Constant(+)
  //                           </Option>
  //                           <Option value='multiply_c' key='multiply_c'>
  //                             Multiply Constant(x)
  //                           </Option>
  //                         </Select>
  //                       </div>
  //                     </Col>

  //                     {ra.operator && ra.operator !== "none" ? (
  //                       ra.operator &&
  //                       (ra.operator === "add_c" ||
  //                         ra.operator === "multiply_c") ? (
  //                         <>
  //                           <Col span={6}>
  //                             <div>Field Name:</div>
  //                             <div>
  //                               <Select
  //                                 style={{ width: "90%" }}
  //                                 placeholder='Select Data Field'
  //                                 value={ra.fieldName}
  //                                 defaultValue={'none'}
  //                                 onChange={(val) =>
  //                                   updateBuilderByIndex(
  //                                     fi,
  //                                     "fieldName",
  //                                     val,
  //                                     ra,
  //                                     n
  //                                   )
  //                                 }
  //                               >
  //                                 <Option value='none' key='none'>
  //                                   None
  //                                 </Option>
  //                                 {props?.availableFields?.map(
  //                                     (af, j) => {
  //                                       return (
  //                                         <Option
  //                                           value={af.fieldName}
  //                                           key={fi.id + "_1_" + j + "_" + n}
  //                                         >
  //                                           {af.fieldName}
  //                                         </Option>
  //                                       );
  //                                     }
  //                                   )}
  //                               </Select>
  //                             </div>
  //                           </Col>
  //                           <Col span={6}>
  //                             <div>Constant Value:</div>
  //                             <div>
  //                               <Input
  //                                 type='number'
  //                                 onChange={(e) =>
  //                                   updateBuilderByIndex(
  //                                     fi,
  //                                     "const_1",
  //                                     e.target.value,
  //                                     ra,
  //                                     n
  //                                   )
  //                                 }
  //                               />
  //                             </div>
  //                           </Col>
  //                         </>
  //                       ) : ra.operator &&
  //                         (ra.operator === "sum" || ra.operator === "avg") ? (
  //                         <Col span={6}>
  //                           <div>Field Names:</div>
  //                           <div>
  //                             <Select
  //                               mode='multiple'
  //                               showArrow
  //                               tagRender={tagRender}
  //                               style={{ width: "100%", minWidth: "200px" }}
  //                               value={ra.fieldNamesList?.map(i => i)}
  //                               options={props.availableFields?.map((af) => {
  //                                 return { value: af.fieldName };
  //                               })}
  //                               onChange={(val) =>
  //                                 updateBuilderByIndex(
  //                                   fi,
  //                                   "fieldNamesList",
  //                                   val,
  //                                   ra,
  //                                   n
  //                                 )
  //                               }
  //                             />
  //                           </div>
  //                         </Col>
  //                       ) : ra.operator && ra.operator === "func" ? (
  //                         <Col span={8}>
  //                           <div>Function:</div>
  //                           <div>
  //                             <Mentions
  //                               style={{ width: "100%" }}
  //                               onChange={(v) =>
  //                                 updateBuilderByIndex(
  //                                   fi,
  //                                   "calculationStr",
  //                                   v,
  //                                   ra,
  //                                   n
  //                                 )
  //                               }
  //                               placeholder='@field1 + @field2...'
  //                               value={ra.calculationStr?ra.calculationStr:''}
  //                             >
  //                               {props.availableFields
  //                                 ?.filter((af) => af.dataType === "number" || af.dataType === "float")
  //                                 ?.map((af) => (
  //                                   <Mentions.Option
  //                                     key={af.fieldName}
  //                                     value={`${af.fieldName}$`}
  //                                   >
  //                                     {af.fieldName}
  //                                   </Mentions.Option>
  //                                 ))}
  //                             </Mentions>
  //                           </div>
  //                           <div>Ex: {`@field1$ - @field2$..`}</div>
  //                         </Col>
  //                       ) : null
  //                     ) : null}
  //                   </React.Fragment>
  //                 );
  //               })}
  //               <Col span={1} offset={1}>
  //                 <div>&nbsp;</div>
  //                 <div>
  //                   <Button
  //                     type='text'
  //                     icon={<CloseOutlined />}
  //                     onClick={() => deleteBuilderItem(fi)}
  //                   />
  //                 </div>
  //               </Col>
  //             </Row>
  //           );
  //         })}

  //         <Row style={{ marginTop: "16px", marginBottom: "32px" }} gutter={16}>
  //           <Col span={4}>
  //             <Button onClick={setBuilderItem}>Add New +</Button>
  //           </Col>

  //           <Col span={3}>
  //             <Button type='primary' onClick={() => applyBuilders(builders)}>
  //               Apply
  //             </Button>
  //           </Col>
  //         </Row>
  //         <hr />
  //         <Row gutter={16} style={{ marginBlock: "2rem" }}>
  //           <Col span={5}>
  //             <Button onClick={() => clearBuilders()}>Reset</Button>
  //           </Col>
  //         </Row>
  //       </div>
  //     ) : (
  //       <div>
  //         <NotFound />
  //       </div>
  //     )}
  //   </div>
  // );
  return (
    <div className="data-builder-wrapper">
      {returnDataArrayObject(props.reportDataObject) ? (
        <div>
          <div className="builder-rows-container">
            {builders.map((fi, builderIndex) => (
              <div key={"fil_" + fi.id} className="builder-row">
                {/* 2-column grid for fields */}
                <div className="builder-column-row">
                  <div className="builder-field">
                    <label>Display Name</label>
                    <Input
                      placeholder="Display Name"
                      value={fi.displayName}
                      onChange={(e) => updateBuilder(fi, "displayName", e.target.value)}
                    />
                  </div>

                  {fi.rowAggregation.map((ra, n) => (
                    <React.Fragment key={`art_${fi.id}_${n}`}>
                      <div className="builder-field">
                        <label>Operation</label>
                        <Select
                          value={ra.operator}
                          defaultValue="none"
                          onChange={(val) => updateBuilderByIndex(fi, "operator", val, ra, n)}
                        >
                          <Option value="none">None</Option>
                          <Option value="sum">Sum</Option>
                          <Option value="avg">Average</Option>
                          <Option value="func">Function</Option>
                          <Option value="add_c">Add Constant(+)</Option>
                          <Option value="multiply_c">Multiply Constant(x)</Option>
                        </Select>
                      </div>

                      {ra.operator && ra.operator !== "none" ? (
                        ra.operator === "add_c" || ra.operator === "multiply_c" ? (
                          <>
                            <div className="builder-field">
                              <label>Field Name</label>
                              <Select
                                placeholder="Select"
                                value={ra.fieldName}
                                defaultValue="none"
                                onChange={(val) => updateBuilderByIndex(fi, "fieldName", val, ra, n)}
                              >
                                <Option value="none">None</Option>
                                {props?.availableFields?.map((af, j) => (
                                  <Option value={af.fieldName} key={fi.id + "_1_" + j + "_" + n}>
                                    {af.fieldName}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                            <div className="builder-field">
                              <label>Constant Value</label>
                              <Input
                                type="number"
                                onChange={(e) => updateBuilderByIndex(fi, "const_1", e.target.value, ra, n)}
                              />
                            </div>
                          </>
                        ) : ra.operator === "sum" || ra.operator === "avg" ? (
                          <div className="builder-field" style={{ gridColumn: "1 / -1" }}>
                            <label>Field Names</label>
                            <Select
                              mode="multiple"
                              showArrow
                              tagRender={tagRender}
                              value={ra.fieldNamesList?.map((i) => i)}
                              options={props.availableFields?.map((af) => ({ value: af.fieldName }))}
                              onChange={(val) => updateBuilderByIndex(fi, "fieldNamesList", val, ra, n)}
                            />
                          </div>
                        ) : ra.operator === "func" ? (
                          <div className="builder-field" style={{ gridColumn: "1 / -1" }}>
                            <label>Function</label>
                            <Mentions
                              onChange={(v) => updateBuilderByIndex(fi, "calculationStr", v, ra, n)}
                              placeholder="@field1 + @field2..."
                              value={ra.calculationStr ? ra.calculationStr : ""}
                            >
                              {props.availableFields
                                ?.filter((af) => af.dataType === "number" || af.dataType === "float")
                                ?.map((af) => (
                                  <Mentions.Option key={af.fieldName} value={`${af.fieldName}$`}>
                                    {af.fieldName}
                                  </Mentions.Option>
                                ))}
                            </Mentions>
                            <span style={{ fontSize: "10px", color: "#8c8c8c" }}>Ex: @field1$ - @field2$</span>
                          </div>
                        ) : null
                      ) : null}
                    </React.Fragment>
                  ))}
                </div>

                {/* Remove — outside grid, right aligned. The first builder always stays,
                    so Remove appears from the second one onward. */}
                {builderIndex > 0 ? (
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button type="text" className="filter-remove-btn" onClick={() => deleteBuilderItem(fi)}>
                      <img src={DeleteIcon} alt="delete-icon" /> Remove
                    </Button>
                  </div>
                ) : null}
              </div>
            ))}
          </div>

          <Button type="link" className="builder-add-btn" onClick={setBuilderItem}>
            + Add New
          </Button>

          {/* <div className="builder-actions">
            <Button type="primary" onClick={() => applyBuilders(builders)}>
              Apply
            </Button>
            <Button onClick={clearBuilders}>Reset</Button>
          </div> */}
        </div>
      ) : (
        <NotFound />
      )}
    </div>
  );
}
